
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-fill",attrs:{"d":"M13 24h14v12H13zM13 14v-4h14v4zM13 18v-2h6v2zM21 18v-2h6v2zM15 21a1 1 0 1 1-2 0 1 1 0 0 1 2 0M18 21a1 1 0 1 1-2 0 1 1 0 0 1 2 0M21 21a1 1 0 1 1-2 0 1 1 0 0 1 2 0M24 21a1 1 0 1 1-2 0 1 1 0 0 1 2 0M27 21a1 1 0 1 1-2 0 1 1 0 0 1 2 0","fill":"#D0EFEC"}}),_c('path',{staticClass:"i-Rectangle 16",attrs:{"stroke":"#234652","d":"M32 6h33v24H32z","transform":"rotate(90 32 6)"}}),_c('path',{staticClass:"i-Line 20",attrs:{"stroke":"#234652","d":"M34.5 9.5h2v27h-2"}}),_c('path',{staticClass:"i-Line 21",attrs:{"stroke":"#234652","d":"M38.5 12.5h2v21h-2"}}),_c('path',{staticClass:"i-Line 37",attrs:{"stroke":"#234652","stroke-linecap":"square","stroke-miterlimit":"16","d":"M11.178 30H24"}}),_c('path',{staticClass:"i-Rectangle 37",attrs:{"stroke":"#234652","d":"m21.033 33.81 3.818-3.817-3.818-3.819"}})])
          )
        }
      }
    